//AOS SCRIPT START
AOS.init({
    duration: 1200,
    disable: 'phone, tablet, mobile',
});
AOS.refresh();
AOS.refreshHard();
//AOS SCRIPT END

//CARDS SCROLL ANIMATION  SCRIPT START
$(document).ready(function () {
    setTimeout(function () {
        var cardItem = $(".image-text-card-carousel .owl-carousel .owl-item,.featured");
        $(cardItem).each(function (i, el) {
            if (i % 2 === 0) {
                $(this).find(".item,.image-text-card,.image-text-goals-card").attr("data-aos", "fade-up");
            }
            else {
                $(this).find(".item,.image-text-card,.image-text-goals-card").attr("data-aos", "fade-down");
            }
        });
        AOS.refresh();
        AOS.refreshHard();
    }, 0);
});
  //CARDS SCROLL ANIMATION  SCRIPT END
